// assets
import { ChromeOutlined, HistoryOutlined } from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  HistoryOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'support',
  title: 'Support',
  type: 'group',
  children: [
    {
      id: 'feedback-page',
      title: 'Feedback Page',
      type: 'item',
      url: '/feedback-page',
      icon: icons.ChromeOutlined
    },
    {
      id: 'changelog',
      title: 'Changelog',
      type: 'item',
      url: '/changelog',
      icon: icons.HistoryOutlined
    }
  ]
};

export default support;
